import { FAMILY } from "@/settings/widgetFamilies";

export const GRANULARITY_CONTROL_NAME = "granularity";
export const INVERSE_CONTROL_NAME = "inverse";
export const DIMENSION_SELECTOR_CONTROL_NAME = "dimensionSelector";
export const DIMENSION_CONTROL_NAME = "dimension";
export const PRIMARY_METRIC_CONTROL_NAME = "primaryMetric";
export const PRIMARY_METRIC_DEFAULT_NAME = "displayMetric";
export const DEFAULT_DATA_LABEL_SIZE = 14;

export const palette = {
  default: 0,
};

export const legendPosition = {
  default: null,
  type: "legend",
  label: "Legend Position",
  dictionary: "legendPositions",
};

export const lineThickness = {
  default: 3,
  type: "select",
  label: "Line Thickness",
  dictionary: "lineThickness",
};

export const showItems = {
  default: 5,
  type: "select",
  label: "Show Items",
  dictionary: "showItems",
};

export const compactFormat = {
  default: false,
  type: "checkbox",
  label: "Compact Form",
};

export const showDataLabels = {
  default: true,
  type: "checkbox",
  label: "Show Data Labels",
};

export const showDataLabelsLegend = {
  default: true,
  type: "checkbox",
  label: "Show Data Labels Legend",
};

export const showBarDataLabels = {
  default: true,
  type: "checkbox",
  label: "Show Bar Data Labels",
};

export const showLineDataLabels = {
  default: false,
  type: "checkbox",
  label: "Show Line Data Labels",
};

export const dataLabelsSizes = {
  default: DEFAULT_DATA_LABEL_SIZE,
  type: "select",
  label: "Data Labels Size",
  dictionary: "dataLabelsSizes",
};

export const dataLabelsLinesSizes = {
  default: DEFAULT_DATA_LABEL_SIZE,
  type: "select",
  label: "Data Labels Line Size",
  dictionary: "dataLabelsSizes",
};

export const dataLabelsTopEntries = {
  default: null,
  type: "number",
  label: "Top Data Labels Count",
};

export const dataLabelsCompact = {
  default: null,
  type: "checkbox",
  label: "Compact Data Labels",
};

export const dataLabelsDecimals = {
  default: null,
  type: "number",
  label: "Data Labels Decimals",
};

export const dataLabelsHideThreshold = {
  default: 80,
  type: "number",
  label: "Data Labels Hide Threshold (px)",
};

export const dataLabelsFlipHorizontally = {
  default: false,
  type: "checkbox",
  label: "Show Labels Horizontally",
};

export const dataLabelsShowPercent = {
  default: false,
  type: "checkbox",
  label: "Show Share Percent",
};

export const dimensionSelector = {
  default: false,
  type: "checkbox",
  label: "Dimension Selector",
};

export const primaryMetricSelector = {
  default: false,
  type: "checkbox",
  label: "Primary Metric Selector",
};

export const summaryRow = {
  name: "summary",
  default: false,
  type: "checkbox",
  label: "Summary Row",
};

/* Controls */

export const inverse = {
  name: INVERSE_CONTROL_NAME,
  default: false,
  type: "switch",
  label: "Inverse",
  families: [FAMILY.COMPARISON, FAMILY.DECOMPOSITION],
};

export const granularity = {
  name: GRANULARITY_CONTROL_NAME,
  default: "month",
  type: "select",
  label: "Granularity",
  dictionary: "timeMetrics",
  families: [FAMILY.OVERTIME],
};

export const dimension = {
  name: DIMENSION_CONTROL_NAME,
  default: "",
  type: "select",
  label: "Dimension",
  dictionary: "dimensionMetrics",
  metricName: "decompositionMetric",
  families: [FAMILY.RELATIONSHIPS, FAMILY.COMPARISON, FAMILY.DECOMPOSITION, FAMILY.DISTRIBUTION, FAMILY.OVERTIME],
};

export const primaryMetric = {
  name: PRIMARY_METRIC_CONTROL_NAME,
  default: "",
  type: "select",
  label: "Primary Metric",
  dictionary: "displayMetrics",
  metricName: PRIMARY_METRIC_DEFAULT_NAME,
  families: [FAMILY.RELATIONSHIPS, FAMILY.COMPARISON, FAMILY.DECOMPOSITION, FAMILY.DISTRIBUTION, FAMILY.OVERTIME],
};

export const allControls = [inverse, granularity, summaryRow, dimension, primaryMetric];
